import {AfterContentChecked, Component, EventEmitter, Input, Output} from '@angular/core';
import {DomainMetadataVO} from '../../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../../generate/ChangeVO';

@Component({
    selector: 'meta-data-view',
    templateUrl: './meta-data-view.component.html',
    styleUrls: ['./meta-data-view.component.scss'],
    standalone: false
})
export class MetaDataViewComponent implements AfterContentChecked {
  @Input()
  tldMetadata: DomainMetadataVO;

  @Input()
  domainType: any;

  @Input()
  domainStatus: any;

  @Input()
  change: ChangeVO;

  @Input()
  lastchange: string;

  @Output()
  edit = new EventEmitter<boolean>();
  @Input()
  viewMode: boolean;
  constructor() {
  }

  ngAfterContentChecked() {
  }

  onEdit(): void {
    this.edit.emit(true);
  }

}
